<template>
    <div class="mobile-common-menu mobile-common-menu--auth" :class="{'mobile-common-menu--open': mobileAccountMenu}">
        <template v-if="mobileAccountMenu">
            <div class="mobile-common-menu__container js-mobile-menu-container">
                <div class="mobile-common-menu__container-inner">
                    <div class="mobile-common-menu__content">
                        <ul class="mobile-common-menu__links">
                            <template v-if="user">
                                <li class="mobile-menu__link" v-for="(page, i) in accountPages" :key="i">
                                    <a href="#" @click.prevent="goTo(page.path)" :class="{active: isActiveRoute(page.path)}">{{ page.name }}</a>
                                </li>
                                <li class="mobile-menu__link">
                                    <a href="#" @click.prevent="logoutHandler()">{{ $t('auth.logout') }}</a>
                                </li>
                            </template>
                            <template v-else>
                                <li class="mobile-menu__link">
                                    <a href="#" @click.prevent="goTo(i18nLink('login'))">
                                        {{ $t('auth.login') }}
                                    </a>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
            <a href="#" @click.prevent="$store.dispatch('SET_MOBILE_ACCOUNT_MENU', false)" class="mobile-common-menu__btn -red">
                <span class="material-icon icon-clear"/>
            </a>
        </template>
        <a v-else href="#" class="action-link" @click.prevent="$store.dispatch('SET_MOBILE_ACCOUNT_MENU', true)">
            <span class="material-icon icon-account_circle"/>
            <span class="action-link__txt">{{ $t('account.profile') }}</span>
        </a>
    </div>
</template>

<script>
  import MobileAccountMenu from 'src/mixins/mobileAccountMenuComponent';

  export default {
    mixins: [MobileAccountMenu],
  };
</script>
